import { apiCallWrapper } from 'traveldesk-ui'
import Region from './../models/Region'

export default class RegionsApiService {
    public static async getSupplierRegions(dispatch: any) {
        return await apiCallWrapper<Region[]>('/api/regions/supplier', 'GET', dispatch)
    }
}
